module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOUlEQVQ4y2NgGBzAuO8/DIPAZSUtMAYBZDkMPHgM+I8GkA3AB+AGwDSQiqlnAMVeGAbRSLkBQxoAAJcrc1wIOFfOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IS.png
// module id = 1172
// module chunks = 0